import {
    GetEnrollmentStatus,
    useServerEnrolledStatsigExperiment,
} from '@eventbrite/discover-utils';

/**
 * Hook to get the experiment treatment value for the promoted results carousel test.
 * Returns both loading state and the treatment value to prevent flickering.
 * Link to experiment: https://console.statsig.com/7n3hq8N8FgwqPLIkQ9P62X/experiments/ads_promoted_search_result_carousel/setup
 */
export const usePromotedEventCarouselExperiment = () => {
    const { status, variant } = useServerEnrolledStatsigExperiment<boolean>({
        name: 'ads_promoted_search_result_carousel',
        paramName: 'show_search_result_ad_carousel',
        defaultValue: false,
    });

    return {
        isLoading: status === GetEnrollmentStatus.LOADING,
        isEnabled: variant,
    };
};
